import { ViewConfig } from "@lib/views";
import { OrganizationServiceActionsCell } from "./cells/OrganizationServiceActionsCell";
import { OrganizationServiceNameCell } from "./cells/OrganizationServiceNameCell";
import { OrganizationServiceUpdatedCell } from "./cells/OrganizationServiceUpdatedCell";

export enum OrganizationServiceColumn {
    NAME = "name",
    UPDATED = "updated",
    ACTIONS = "actions",
}

export interface OrganizationServiceRow {
    id: string;
    name: string;
    updatedAt: Date;
    organizationId: string;
}

export const organizationServicesViewConfig: ViewConfig<
    OrganizationServiceRow,
    OrganizationServiceColumn,
    never
> = {
    columns: {
        [OrganizationServiceColumn.NAME]: {
            accessorKey: "name",
            name: "Name",
            header: "Name",
            cell: OrganizationServiceNameCell,
            minSize: 220,
            maxSize: 1200,
        },
        [OrganizationServiceColumn.UPDATED]: {
            accessorKey: "updatedAt",
            name: "Updated",
            header: "Updated",
            cell: OrganizationServiceUpdatedCell,
            minSize: 140,
            maxSize: 180,
        },
        [OrganizationServiceColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: OrganizationServiceActionsCell,
            minSize: 64,
            maxSize: 64,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
